const urlAPI = process.env.REACT_APP_HOST;
//const urlAPI = 'http://192.168.0.4:8000';

const getUrlAPIv1 = `${urlAPI}/api/v1`;

const getUrlAPIv2 = `${urlAPI}/api/v2`;

const getUrlAPIv3 = `${urlAPI}/api/v3`;

const getUrlAPIv4 = `${urlAPI}/api/v4`;

const versionWebSite = '0.0.8'

const urlWebSite = 'https://vokere.com';

//const urlWebSite = 'http://192.168.0.4:3000';

export { getUrlAPIv1, getUrlAPIv2, getUrlAPIv3, getUrlAPIv4, versionWebSite, urlWebSite, urlAPI };